import React  from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {createStructuredSelector} from 'reselect'
import Raven from 'raven-js'
import Cookies from 'js-cookie'

import * as actions from './actions'
import selectors from './selectors'
import {
  Widget
} from '../ChatWidget'
import BotService from './services/BotService'
import AvatarBot from 'assets/avatar_bot.png'
import AvatarUser from 'assets/avatar_user.png'
import TrackingHOC from '../hocs/TrackingHOC'
import { ConfigContext } from '../ConfigContext'

class App extends React.Component {
  constructor(props) {
    super(props)

    BotService.configure({
      ...props.config,
      userId: Cookies.get('user_id'),
      pushEvent: props.pushEvent
    })
  }


  componentDidCatch(error, errorInfo) {
    Raven.captureException(error, { extra: errorInfo })
  }

  render() {
    const {config} = this.props
    return (
      <div className="db-chatbot" style={{ height: '100%' }}>
        <ConfigContext.Provider value={config}>
          <Widget
            avatarBot={config.avatarBot || AvatarBot}
            avatarUser={config.avatarUser || AvatarUser}
            launcher={config.launcher}
            title={config.title || 'DeviceBits Bot'}
            subtitle=""
            inputDisabled={this.props.forceReply}
            onStartConversation={this.props.startConversation}
            onCloseConversation={this.props.closeConversation}
            config={config}
          />
        </ConfigContext.Provider>
      </div>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  isFetching: selectors.isFetching,
  forceReply: selectors.forceReply,
})

const mapDispatchToProps = dispatch => ({
  startConversation: (config) => dispatch(actions.startConversation(config)),
  closeConversation: () => dispatch(actions.closeConversation()),
})

App.propTypes = {
  config: PropTypes.shape({
    apiKey: PropTypes.string,
    backend: PropTypes.string.isRequired,
    botId: PropTypes.string.isRequired,
    avatarBot: PropTypes.string,
    avatarUser: PropTypes.string,
    launcher: PropTypes.shape({
      icon: PropTypes.string,
      minimizedIcon: PropTypes.string,
      height: PropTypes.number,
    }),
    title: PropTypes.string,
  }).isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(TrackingHOC(App))



// WEBPACK FOOTER //
// ./src/App/index.js